import { cn } from '@eombor/ui';
import type { BarDatum } from '../model/chart-data.js';

/**
 * Eng ko'p chiqqan mahsulotlar — GORIZONTAL ustunlar.
 *
 * Gorizontal, chunki o'qiladigan narsa mahsulot NOMI: vertikal ustunlarda
 * uzun nomlar qiyshaytirib yoziladi va grafik o'qilmay qoladi.
 */

/**
 * Ustunning JIDDIYLIGI — 0..1 oralig'ida, `undefined` bo'lsa neytral.
 *
 * Bu bezak emas, ma'lumot: chegaraning 10% i qolgan mahsulot bilan 90% i
 * qolgani bir xil ko'k ustun bo'lsa, ro'yxatning ustki uchtasi pastki
 * uchtasidan farq qilmasdi va odam har birining raqamini o'qishga
 * majbur bo'lardi.
 */
const severityClass = (ratio: number | undefined): string => {
  if (ratio === undefined) return 'bg-accent';
  if (ratio < 0.25) return 'bg-danger';
  if (ratio < 0.6) return 'bg-warn';
  return 'bg-success';
};

export interface TopItemsBarProps {
  items: readonly BarDatum[];
  /** Har satrdagi miqdordan keyingi umumiy birlik. Birlik satrga xos
   *  bo'lsa bo'sh qoldiriladi va `hint` da beriladi. */
  unitLabel?: string;
}

const format = (value: number): string => value.toLocaleString('ru-RU');

export const TopItemsBar = ({ items, unitLabel = '' }: TopItemsBarProps) => {
  const max = Math.max(1, ...items.map((item) => item.value));

  return (
    <ul className="flex flex-col gap-3">
      {items.map((item) => (
        <li key={item.id} className="flex flex-col gap-1">
          <div className="flex items-baseline justify-between gap-3">
            <span className="min-w-0 truncate text-sm text-text">{item.label}</span>
            <span className="tabular shrink-0 text-sm font-medium text-text">
              {format(item.value)} <span className="font-normal text-text-faint">{unitLabel}</span>
            </span>
          </div>
          <div className="flex items-center gap-2">
            <div className="h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-surface-2">
              <div
                className={cn('h-full rounded-full transition-[width]', severityClass(item.severity))}
                style={{
                  /* Eng kamida 2% — nolga yaqin qiymat butunlay yo'qolib
                     ketmasin: "ustun yo'q" bilan "satr yo'q" boshqa gap. */
                  width: `${Math.max(2, (item.value / max) * 100)}%`,
                }}
              />
            </div>
            <span className="tabular shrink-0 text-xs text-text-faint">{item.hint}</span>
          </div>
        </li>
      ))}
    </ul>
  );
};
